import axios, { type AxiosResponse } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import type { ISportsGroup } from 'core/models/api/sports-group/sports-group-piloting'
import type { CreateSportsGroupDto, PutSportsGroupDto } from '../rest/mutations/sports-group-save'
import { QUERY_KEY_SPORTS_GROUP } from './useApiGetSportsGroup'
import {
  GROUPS_NOTIFICATION_SPORTS_CREATION_FAILED,
  GROUPS_NOTIFICATION_SPORTS_CREATION_SUCCEDED,
  GROUPS_NOTIFICATION_SPORTS_EDITION_FAILED,
  GROUPS_NOTIFICATION_SPORTS_EDITION_SUCCEDED
} from 'core/constants/translations/groups'
import { useTranslation } from 'react-i18next'

export const useApiPostSportsGroup = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (sportsGroup: ISportsGroup) => {
      if (sportsGroup.id) {
        const dto: PutSportsGroupDto = {
          id: sportsGroup.id,
          label: sportsGroup.label,
          composition: sportsGroup.composition.map(item => {
            return {
              index: item.index,
              sport_id: item.sport_id
            }
          })
        }
        return axios.put(`/sports_groups/${sportsGroup.id}`, dto)
      } else {
        const dto: CreateSportsGroupDto = {
          label: sportsGroup.label,
          composition: sportsGroup.composition.map(item => {
            return {
              index: item.index,
              sport_id: item.sport_id
            }
          })
        }
        return axios.post('/sports_groups', dto)
      }
    },
    onSuccess: (response: AxiosResponse) => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SPORTS_GROUP] })
      response.config.method === 'post' && toast.success(t(GROUPS_NOTIFICATION_SPORTS_CREATION_SUCCEDED))
      response.config.method === 'put' && toast.success(t(GROUPS_NOTIFICATION_SPORTS_EDITION_SUCCEDED))
    },
    onError: (response: AxiosResponse) => {
      response.config.method === 'post' && toast.error(t(GROUPS_NOTIFICATION_SPORTS_CREATION_FAILED))
      response.config.method === 'put' && toast.error(t(GROUPS_NOTIFICATION_SPORTS_EDITION_FAILED))
    }
  })
}
